import Experience from "../Experience";
import * as THREE from 'three'

export default class Floor
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources


        //Setup 
        this.resource = this.resources.items.snowFloor

        this.setModel()
        // this.setCube()
    }

    setModel()
    {
        this.model = this.resource.scene
        this.model.scale.setScalar(7.3)
        this.model.position.set(7.5, 0.8, 2.5)
        this.model.rotation.z = Math.PI * -0.017
        this.scene.add(this.model)

        this.model.traverse((child) =>
        {
            if(child instanceof THREE.Mesh)
            {
                child.receiveShadow = true
            }
        })
    }

    setCube()
    {

        this.meshMaterial = new THREE.MeshStandardMaterial()
        this.mesh = new THREE.Mesh(
            new THREE.BoxGeometry(32.7, 10, 29),
            new THREE.MeshStandardMaterial({
                color: '#d1d1d1'
            })
        )
        this.scene.add(this.mesh)

        this.mesh.position.set(6.5, -5.1, 1.8)
        this.mesh.rotation.x = Math.PI * -0.009


    }

}